'use client'

import { AccountMenuProvider } from '../../context/AccountMenuProvider'
import { AccountActions } from '../AccountActions/AccountActions'

export function AccountActionsWrapper({
	hasFavorites,
}: {
	readonly hasFavorites: boolean
}) {
	return (
		<AccountMenuProvider>
			<AccountActions hasFavorites={hasFavorites} />
		</AccountMenuProvider>
	)
}
